import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { modules } from './i18n.interface';

/**
 * @description Load translations.
 * @exports
 * @param {HttpClient} http Http client.
 * @returns {ModuleTranslateLoader}
 */
export function moduleHttpLoaderFactory(http: HttpClient) {
  return new ModuleTranslateLoader(http, { modules, lowercaseNamespace: true });
}

/**
 * I18n Module.
 *
 * @exports
 * @class i18nModule
 */
@NgModule({
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: moduleHttpLoaderFactory,
        deps: [HttpClient]
      },
      fallbackLang: 'en'
    })
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class i18nModule {}
